export const optionsFrequenzaFarmaco = [
    { value: '', label: 'Da definire', disabled: true},
    { value: 'daily', label: 'Giornaliero'},
    { value: 'weekly', label: 'Settimanale'},
    { value: 'monthly', label: 'Mensile'},
];
